import { createSlice } from "@reduxjs/toolkit";
import {
  getLogin,
  postProfile,
  postLogin,
  editPersonal,
  changePassword,
  resetPassword,
  resetNewPassword,
  getPermissionUser,
} from "../../API/AuthAPI";
import { persistor } from "../../redux/store";

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  Profile: [],
  LogIn: [],
  EditUser: [],
  Password: [],
  ResetPassword: [],
  NewPassword: [],
  Permission: [],
  loading: false,
};

export const AuthenSlice = createSlice({
  name: "AuthenState",
  initialState,
  reducers: {
    updateGetUser: (state, action) => {
      state.LogIn = action.payload;
    },
    updateLogin: (state, action) => {
      state.isAuthenticated = action.payload.auth;
      state.user = action.payload.result;
      state.token = action.payload.token;
    },
    // logout: (state) => {
    //   state.isAuthenticated = false;
    //   state.user = null;
    //   state.token = null;
    // },
    logout: () => initialState,
    updateProfile: (state, action) => {
      state.Profile = action.payload;
    },
    updateEditPersonol: (state, action) => {
      state.EditUser = action.payload;
    },
    updateChangePassword: (state, action) => {
      state.Password = action.payload;
    },
    updateResetPassword: (state, action) => {
      state.ResetPassword = action.payload;
    },
    updateNewPassword: (state, action) => {
      state.NewPassword = action.payload;
    },
    getPermissionUsers: (state, action) => {
      state.Permission = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { updateLogin } = AuthenSlice.actions;

export const postLoginDetail =
  ({ username, password }) =>
  async (dispatch) => {
    const value = { username, password };
    try {
      const data = await postLogin(value);
      dispatch(updateLogin(data));

      if (data && data.status === true) {
        try {
          await dispatch(
            getUserDetail({
              idUser: data.id,
              token: data.token,
            })
          );

          await dispatch(
            getPermissionUserDetail({
              idUser: data.id,
              token: data.token,
            })
          );
        } catch (error) {
          console.error("Error while dispatching actions:", error);
        }
      } else {
        return data;
      }
      return data;
    } catch (error) {
      throw error;
    }
  };

export const { setLoading } = AuthenSlice.actions;

export const { logout } = AuthenSlice.actions;
export const getLogOut = () => async (dispatch) => {
  try {
    await dispatch(logout());
    await persistor.purge();
  } catch (error) {
    console.error("Error occurred during logout:", error);
  }
};

export const { updateGetUser } = AuthenSlice.actions;
export const getUserDetail = (value) => async (dispatch) => {
  await getLogin(value).then(async (data) => {
    await dispatch(updateGetUser(data));
  });
};

export const { updateProfile } = AuthenSlice.actions;
export const postProfileDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await postProfile(value);
    dispatch(updateProfile(data));
    dispatch(setLoading(false));
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateEditPersonol } = AuthenSlice.actions;
export const editPersonalDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await editPersonal(value);
    dispatch(updateEditPersonol(data));
    dispatch(setLoading(false));
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateChangePassword } = AuthenSlice.actions;
export const changePasswordDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await changePassword(value);
    dispatch(updateChangePassword(data));

    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateResetPassword } = AuthenSlice.actions;
export const resetPasswordDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await resetPassword(value);
    dispatch(updateResetPassword(data));

    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { updateNewPassword } = AuthenSlice.actions;
export const newPasswordDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const data = await resetNewPassword(value);
    dispatch(updateNewPassword(data));

    dispatch(setLoading(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoading(false));
  }
};

export const { getPermissionUsers } = AuthenSlice.actions;
export const getPermissionUserDetail = (value) => async (dispatch) => {
  await getPermissionUser(value).then(async (data) => {
    await dispatch(getPermissionUsers(data));
  });
};

export default AuthenSlice.reducer;
